<script>
import Anxunheader from "@/views/Anxun/components/Anxunheader.vue";
import kefu from "@/views/kefu.vue";
import headtip from "@/views/headTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import { shareUrl } from "@/utils/vxshare";
import consultTip from "@/components/consultTip.vue";
// 页面内容常量
const PAGE_CONTENT = {
  headertitle1: "软件部署及运维服务\n\n\n",
  headertitle2: "从安装部署到日常运维的全流程产品支持，确保系统稳定运行与高可用性\n\n\n",
  headerimg: require("@/assets/Inspection1.png"),
  introduce: "基于安全法规和行业标准，构建隐患与风险知识库，结合多终端技术，实现风险管控、隐患排查、整改、验收及管理。通过智能分析、预测预警和安全绩效管理，提升安全管理效率和风险控制能力。\n",
  painPoints: [
    {
      icon: 'team',  // 图标类型
      title: '专业运维团队缺乏',
      description: '缺乏及时响应能力和复杂问题的诊断支撑，且依赖人工操作，易发生错误且难以溯源，进一步降低运维效率并加重运维负担。'
    },
    {
      icon: 'system',
      title: '系统扩展性低',
      description: '固定硬件配置无法灵活调整，限制系统弹性，导致数据量激增时查询效率下降，影响用户体验。'
    },
    {
      icon: 'security',
      title: '安全防护不足',
      description: '敏感数据未加密存储，身份验证机制薄弱，且防护规则不完善，导致系统易受非法获取、篡改及外部攻击的威胁。'
    }
  ]
};

// 桌面端数据
const SECTION_DATA = [
  {
    title: "业务痛点与挑战",
    img: "/OM1.png"
  },
  {
    title: "服务内容",
    title2: "系统架构优化",
    img: "/OM2.png"
  },
  {
    title2: "7×24 监控与故障恢复",
    img: "/OM3.png"
  },
  {
    title: "客户收益",
    img: "/OM4.png"
  }
];

// 移动端数据
const MOBILE_SECTION_DATA = [
  {
    title: "业务痛点与挑战",
    img: "/OM11.png"
  },
  {
    title: "服务内容",
    title2: "系统架构优化",
    img: "/OM12.png"
  },
  {
    title2: "7×24 监控与故障恢复",
    img: "/OM13.png"
  },
  {
    title: "客户收益",
    img: "/OM14.png"
  }
];

export default {
  name: 'SoftwareOM',
  components: {
    bottomTip,
    kefuMobile,
    Anxunheader,
    kefu,
    headtip,
    consultTip,
  },
  data() {
    return {
      dialogVisible:false,
      title:'',
      model: false,
      texttotal: PAGE_CONTENT,
      data: SECTION_DATA,
      data2: MOBILE_SECTION_DATA,
      challenges: [
        {
          icon: require('@/assets/software/om/team.webp'),  // 团队图标
          title: '专业运维团队缺乏',
          description: '缺乏及时响应能力和复杂问题的诊断支撑，且依赖人工操作，易发生错误且难以溯源，进一步降低运维效率并加重运维负担。'
        },
        {
          icon: require('@/assets/software/om/system.webp'),  // 系统图标
          title: '系统扩展性低',
          description: '固定硬件配置无法灵活调整，限制系统弹性，导致数据量激增时查询效率下降，影响用户体验。'
        },
        {
          icon: require('@/assets/software/om/security.webp'),  // 安全图标
          title: '安全防护不足',
          description: '敏感数据未加密存储，身份验证机制薄弱，且防护规则不完善，导致系统易受非法获取、篡改及外部攻击的威胁。'
        }
      ],
      serviceList: [
        {
          title: '系统架构优化',
          items: [
            '云端与本地化部署支持：提供灵活的部署选项，满足不同场景需求。',
            '多节点冗余设计：通过分布式架构提升系统容灾能力，避免单点故障。',
            '动态扩展能力：支持根据业务规模动态调整资源分配，保证系统性能。',
            '数据一致性保障：使用分布式事务管理技术，确保跨节点数据一致性。'
          ]
        },
        {
          title: '7×24监控与故障恢复',
          items: [
            '实时性能监控：监测 CPU、内存、磁盘等关键指标，及时发现异常。',
            '告警通知：多级告警机制，确保问题第一时间被发现与处理。',
            '快速恢复策略：制定完善的故障恢复预案，最大限度减少停机时间。',
            '数据备份：定期备份重要数据，防止因意外导致的数据丢失。'
          ]
        }
      ],
      benefitList: [
        {
          icon: require('@/assets/software/om/benefit1.webp'),
          title: '降低运维成本，减少人力投入',
          desc: '通过自动化运维工具和智能监控系统，实现故障自动检测与修复，减少对人工运维的依赖。'
        },
        {
          icon: require('@/assets/software/om/benefit2.webp'),
          title: '系统稳定性增强',
          desc: '提供 7×24 小时实时监控和快速响应机制，及时发现并解决潜在问题，避免影响业务连续性。'
        },
        {
          icon: require('@/assets/software/om/benefit3.webp'),
          title: '系统安全性提升',
          desc: '结合入侵检测、防火墙策略和安全审计，提升系统整体防护能力，抵御外部攻击，确保业务数据安全合规。'
        }
      ]
    };
  },
  methods: {
    setback(index) {
      return index % 2;
    },
    ResizeContainer() {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.model = screenWidth <= 700;
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      const metaKeywords = document.querySelector('meta[name="keywords"]');

      if (metaDescription) {
        metaDescription.setAttribute('content', this.texttotal.headertitle2);
      }
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.texttotal.headertitle1);
      }
    },
    setupShareData() {
      const url = window.location.href;
      const shareData = {
        url,
        pageTitle: this.texttotal.headertitle1,
        pageDescription: this.texttotal.headertitle2,
        pageKeywords: '智慧场站，生产工艺管理，智慧安防管理，AR 智能作业，AR 智能巡检，设备全生命周期管理，设备在线监测与预警，场站数字孪生，安迅数智，油气通GPT'
      };
      shareUrl(shareData);
    },
    clickConsult(item) {
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      this.dialogVisible = false;
    },
  },
  mounted() {
    document.title = this.texttotal.headertitle1;
    this.setMetaTags();
    this.ResizeContainer();
  },
  created() {
    localStorage.setItem("home", 0);
    setTimeout(this.setupShareData, 1000);
  }
};
</script>

<template>
  <!-- 桌面端布局 -->
  <div v-if="!model" ref="total" class="totalmakeHole">
    <div class="topback"
      :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)', position: 'fixed' }">
      <headtip :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
    </div>
    <kefu @toptop="topTop"></kefu>
    <!-- <Anxunheader :title1="texttotal.headertitle1" :title2="texttotal.headertitle2"
      @clickConsult1="$refs.consultTip.dialogVisible = true">
    </Anxunheader> -->
    <Anxunheader :title1=texttotal.headertitle1 :title2=texttotal.headertitle2
        @clickConsult1="clickConsult('油气通')"></Anxunheader>
    <!-- <div v-for="(item, index) in data" :key="index" class="screenmake1"
      :style="index % 2 == 1 ? { 'background-color': 'white' } : { 'background-color': '#ebf1fd' }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="heighLight" v-html="item.title"></div>
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="heighLight1" v-html="item.title2"></div>
      <img :src="require('@/assets' + item.img)">
    </div> -->
    <div class="screenmake1" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">业务痛点与挑战</div>
      <div class="challenges-list">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <!-- 服务内容 -->
    <div class="screenmake1" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">服务内容</div>
      <div class="service-content-list">
        <div v-for="(service, idx) in serviceList" :key="idx" class="service-content-card">
          <div class="service-content-title">{{ service.title }}</div>
          <ul class="service-content-ul">
            <li v-for="(item, i) in service.items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 客户收益 -->
    <div class="screenmake1" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">客户收益</div>
      <div class="benefit-list">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
  </div>

  <!-- 移动端布局 -->
  <div v-else ref="totalModel" class="totalmakeHoleModel">
    <div class="screen1">
      <kefuMobile @topMobile="topTopmobile"></kefuMobile>
      <headtip @showDialog="showPartner"></headtip>

      <div class="layer2">
        <div v-sliden-instep="{ duration: 800 }" class="title1">
          <img loading="lazy" src="@/assets/AnxunLogo.png">
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="title2 title2-primary">
          {{ texttotal.headertitle1 }}
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="title2 title2-secondary">
          {{ texttotal.headertitle2 }}
        </div>
      </div>

      <div class="bottom-content">
        <div v-sliden-instep="{ duration: 2400 }" class="title4">油气数智，简单易行</div>
        <div class="titlle3" @click="clickConsult('油气通')">产品咨询</div>
      </div>
    </div>

    <!-- <div v-for="(item, index) in data2" :key="index" class="screenmake1"
      :style="index % 2 == 1 ? { 'background-color': 'white' } : { 'background-color': '#ebf1fd' }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="heighLight" v-html="item.title"></div>
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="heighLight1" v-html="item.title2"></div>
      <img :src="require('@/assets' + item.img)">
    </div> -->

    <div class="screenmake1" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">业务痛点与挑战</div>
      <div class="challenges-list-mobile">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <div class="screenmake1" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">服务内容</div>
      <div class="service-content-list-mobile">
        <div v-for="(service, idx) in serviceList" :key="idx" class="service-content-card-mobile">
          <div class="service-content-title-mobile">{{ service.title }}</div>
          <ul class="service-content-ul-mobile">
            <li v-for="(item, i) in service.items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="screenmake1" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="heighLight">客户收益</div>
      <div class="benefit-list-mobile">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card-mobile">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div ref="bottom">
      <bottomTip></bottomTip>
    </div>
    <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
  </div>
</template>

<style scoped lang="scss">
// 通用样式
.screenmake1 {
  padding: 5vh 8.09763142692085vw;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;

  img {
    margin: auto;
  }
}

// 桌面端样式
.totalmakeHole {
  .topback {
    z-index: 10;
    padding-left: 3vw;
    width: 100%;
  }

  .screenmake1 {
    background: white;

    .heighLight {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      color: #2D3D4F;
      font-weight: bold;
      font-size: 2.2060658579vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .heighLight1 {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    img {
      width: 70vw;
    }

    //业务痛点与挑战
    .challenges-list {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      .challenge-card {
        // flex: 1;
        margin: 0 15px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 20px;

          img {
            width: 70px;
            height: 70px;
          }
        }

        .challenge-title {
          font-size: 24px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 15px;
        }

        .challenge-desc {
          font-size: 16px;
          color: #333;
          line-height: 1.6;
          text-align: left;
          max-width: 350px; // 添加最大宽度限制
          margin: 0 auto;
        }
      }
    }

    //服务内容
    .service-content-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .service-content-card {
        background: #fff;
        border: 1.5px solid #b6c6e3;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
        padding: 32px 36px;
        min-width: 320px;
        max-width: 600px;
        flex: 1;
        display: flex;
        flex-direction: column;
        // align-items: flex-start;

        .service-content-title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 18px;
          color: #000000;
          text-align: center;
        }

        .service-content-ul {
          padding-left: 18px;

          li {
            font-size: 16px;
            color: #333;
            line-height: 2;
            list-style: disc;
          }
        }
      }
    }

    //@at-root
    .benefit-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .benefit-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);

        padding: 40px 32px 92px 32px;
        min-width: 260px;
        max-width: 380px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .benefit-icon {
          margin-bottom: 24px;

          img {
            width: 150px;
            height: 150px;
          }
        }

        .benefit-title {
          font-size: 24px;
          font-weight: bold;
          color: #222;
          margin-bottom: 18px;
          text-align: center;
          line-height: 1.4;
        }

        .benefit-desc {
          font-size: 16px;
          color: #333;
          // text-align: center;
          line-height: 1.8;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
        }
      }
    }

  }


}

// 移动端样式
.totalmakeHoleModel {
  .screen1 {
    position: relative;
    width: 100%;
    height: 600px;
    padding: 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../../assets/bannerModel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;

    .layer2 {
      position: absolute;
      top: 85px;
      left: 9.17157712305026vw;

      .title1 {
        width: 200px;
        font-size: 3.50606585788562vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2f6eff;
        margin: 10px 0;
      }

      .title2 {
        margin-top: 5px;
        width: 95%;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        line-height: 24px;

        &-primary {
          font-weight: bolder;
          font-size: 25px;
          margin-top: 15px;
          line-height: 30px;
          color: #F44336;
        }

        &-secondary {
          font-weight: bolder;
          margin-top: 15px;
          font-size: 18px;
          line-height: 28px;
          color: #2c3e50;
          text-align: left;
        }
      }
    }

    .bottom-content {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;

      .title4 {
        font-weight: bolder;
        font-size: 18px;
        line-height: 28px;
        padding-bottom: 5px;
        color: #2f6dfd;
      }

      .titlle3 {
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: auto;
        padding: 5px 4.6875vw;
        height: 35px;
        color: white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;
      }
    }
  }

  .screenmake1 {
    padding: 1.78739184177998vh 2.09763142692085vw;

    .heighLight {
      margin: 0 auto;
      text-align: center;
      height: 4.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 6vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .heighLight1 {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 5vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    img {
      width: 90vw;
    }

    .challenges-list-mobile {
      margin-top: 20px;

      .challenge-card {
        margin-bottom: 30px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 15px;

          img {
            width: 50px;
            height: 50px;
          }
        }

        .challenge-title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 10px;
        }

        .challenge-desc {
          font-size: 14px;
          color: #333;
          line-height: 1.5;
          text-align: left;
          max-width: 260px; // 移动端可以设置稍小的宽度
          margin: 0 auto;
        }
      }
    }

    .service-content-list-mobile {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 20px;

      .service-content-card-mobile {
        background: #fff;
        border: 1.5px solid #b6c6e3;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
        padding: 20px 20px;
        width: 100%;

        .service-content-title-mobile {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 12px;
          color: #000000;
          text-align: center;
        }

        .service-content-ul-mobile {
          padding-left: 18px;

          li {
            font-size: 14px;
            color: #333;
            line-height: 2;
            list-style: disc;
          }
        }
      }
    }
  }

  .benefit-list-mobile {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;

    .benefit-card-mobile {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
      padding: 24px 12px 18px 12px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .benefit-icon {
        margin-bottom: 16px;

        img {
          width: 48px;
          height: 48px;
        }
      }

      .benefit-title {
        font-size: 16px;
        font-weight: bold;
        color: #222;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.4;
      }

      .benefit-desc {
        font-size: 13px;
        color: #333;
        text-align: center;
        line-height: 1.7;
        min-height: 36px;
      }
    }
  }

  .benefit-list-mobile {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;

    .benefit-card-mobile {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);
      padding: 24px 12px 38px 12px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .benefit-icon {
        margin-bottom: 16px;

        img {
          width: 100px;
          height: 100px;
        }
      }

      .benefit-title {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.4;
      }

      .benefit-desc {
        font-size: 13px;
        color: #333;
        // text-align: center;
        line-height: 1.7;
        min-height: 36px;
        max-width: 280px;
        margin: 0 auto;
      }
    }
  }
}
</style>